import {
  AppBar,
  Container,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { HeaderTitle } from "./HeaderTitle";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar elevation={0}>
      <Container disableGutters maxWidth="xl">
        <Toolbar sx={{ gap: 2.5 }} component="nav">
          <HeaderTitle isMobile={isMobile} />
          <LanguageSwitcher isMobile={isMobile} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};
